export default function VideoPlayerStore() {
  Alpine.store("videoPlayer", {
    videoId: null,
    headline: "",
    open(id, headline = "") {
      this.videoId = id;
      this.headline = headline;
    },
    close() {
      this.videoId = null;
      this.headline = "";
    },
  });
}
